import { NewVsReturningVertical } from "app/pages/website-analysis/new-vs-returning/NewVsReturningWebAnalysisSingle";
import { Dropdown, DropdownButton, EllipsisDropdownItem } from "@similarweb/ui-components";
import * as _ from "lodash";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import { dateToUTC } from "pro-features/pages/segments/components/benchmarkOvertime/SegmentsVsGroupLineChart";
import markerWithDashedConfig from "pro-features/components/Chart/src/configs/series/markerWithDashedLinePerPointChartConfig";

export const NewVsReturningDropdown = ({ currentMetric, onDropdownChanged }) => {
    return (
        <Dropdown
            // @ts-expect-error Unmatching type
            selectedIds={[currentMetric.dataKey]}
            onClick={onDropdownChanged}
            width={"248px"}
            dropdownPopupPlacement={"ontop-left"}
        >
            {[
                <DropdownButton
                    key={"button"}
                    width={248}
                >
                    {currentMetric.displayText}{" "}
                </DropdownButton>,
                ...Object.values(NewVsReturningVertical).map(({ displayText, dataKey }) => (
                    <EllipsisDropdownItem
                        key={displayText}
                        id={dataKey}
                    >
                        {displayText}
                    </EllipsisDropdownItem>
                )),
            ]}
        </Dropdown>
    );
};

export const transformData = (data, currentMetric, isPercentage?, sites?) => {
    const visibleItems = sites.filter(({ isSelected }) => isSelected);
    return _.map(visibleItems, ({ name: id }, index) => {
        const chartData =
            sites.filter((item: any) => {
                return item.name === id && !item.isSelected;
            }).length > 0
                ? []
                : data?.[id]?.Graph;
        const color = sites.find((legendItem) => legendItem.name === id)?.color;
        const baseSeriesConfig: any = {
            name: id,
            color,
            tooltipIndex: index,
            isSelected: true,
        };
        return combineConfigs(
            {
                ...baseSeriesConfig,
                isDataSingleSeries: true,
                data: Object.entries(chartData).map(([date, dataPoint]) => {
                    if (!dataPoint) {
                        return;
                    }
                    const confidenceLevel = 0.1; // dataPoint?["Confidence"];
                    let value = isPercentage
                        ? dataPoint?.[currentMetric.dataKey] /
                          (dataPoint?.[NewVsReturningVertical.ReturningUsers.dataKey] +
                              dataPoint?.[NewVsReturningVertical.NewUsers.dataKey])
                        : dataPoint?.[currentMetric.dataKey];
                    if (isNaN(parseFloat(value))) {
                        value = null;
                    }
                    return [
                        dateToUTC(date),
                        value,
                        {
                            partial: confidenceLevel >= 0.3 && confidenceLevel < 1,
                            hallowMarker: confidenceLevel >= 0.3 && confidenceLevel < 1,
                            confidenceLevel,
                        },
                    ];
                }),
            },
            [baseSeriesConfig, markerWithDashedConfig],
        );
    });
};
